import {createAction} from 'Shared/utilities/actionCreator';
import * as V from 'Users/models/User/Agent/VipUserType';

export enum VipUserTypeActionType {
  CHANGE_AHL_ACCESS = 'vipUserType/CHANGE_AHL_ACCESS',
  CHANGE_NEW_YORK_ACCESS = 'vipUserType/CHANGE_NEW_YORK_ACCESS',
  CHANGE_IS_EXTERNAL_ADMIN = 'vipUserType/CHANGE_IS_EXTERNAL_ADMIN',
}

export const changeHasAHLAccess = (hasAhlAccess: boolean) =>
  createAction(VipUserTypeActionType.CHANGE_AHL_ACCESS, {hasAhlAccess});
export const changeHasNewYorkAccess = (hasNewYorkAccess: boolean) =>
  createAction(VipUserTypeActionType.CHANGE_NEW_YORK_ACCESS, {hasNewYorkAccess});
export const changeIsExternalAdmin = (isExternalAdmin: boolean) =>
  createAction(VipUserTypeActionType.CHANGE_IS_EXTERNAL_ADMIN, {isExternalAdmin});

export type VIPUserTypeAction =
  | ReturnType<typeof changeHasAHLAccess>
  | ReturnType<typeof changeHasNewYorkAccess>
  | ReturnType<typeof changeIsExternalAdmin>;

type VIPUserTypeState = V.VIPUserType;
const DEFAULT_STATE: VIPUserTypeState = V.DefaultVIPUserType;

export default (state: VIPUserTypeState = DEFAULT_STATE, action: VIPUserTypeAction): VIPUserTypeState => {
  switch (action.type) {
    case VipUserTypeActionType.CHANGE_IS_EXTERNAL_ADMIN:
      return V.changeIsExternalAdministrator(action.payload.isExternalAdmin)(state);
    case VipUserTypeActionType.CHANGE_AHL_ACCESS:
      return V.changeHasAhlAccess(action.payload.hasAhlAccess)(state);
    case VipUserTypeActionType.CHANGE_NEW_YORK_ACCESS:
      return V.changeNewYorkAccess(action.payload.hasNewYorkAccess)(state);
    default:
      return state;
  }
};
